<template>
  <div>
    <hero-component />
    <reviews-component />
    <carousel-component />
    <contact-component />
  </div>
</template>

<script setup>
import HeroComponent from "@/components/home/hero-component.vue";
import ReviewsComponent from "@/components/home/reviews-component.vue";
import CarouselComponent from "@/components/home/carousel-component.vue";
import ContactComponent from "@/components/home/contact-component.vue";
import {computed, onMounted} from "vue";
import {useRoute} from "vue-router";
import {Auth} from "@/core/api/auth.js";
import {ElNotification} from "element-plus";
import {useI18n} from "vue-i18n";
import {useAppStore} from "@/stores/app.js";

const {t} = useI18n()
const appStore = useAppStore()
const route = useRoute()

const token = computed(() => {
  return route.query.token
})
const uid = computed(() => {
  return route.query.uid
})

const activateUser = async () => {
  const res = await Auth.activateUser(route.query.token, route.query.uid)

  if (res.data.activateUser) {
    ElNotification({
      message: t('popup.activationSuccess'),
      type: 'success'
    })
  } else if (res.errors) {
    ElNotification({
      message: res.errors[0].message,
      type: 'error'
    })
  }
}

onMounted( async () => {
  if (uid.value && token.value && route.name === "activate-user") {
    await activateUser();
  }

  if (uid.value && token.value && route.name === "reset-password") {
    await appStore.setActiveState('reset')
  }

  if (route.name === "payment") {
    ElNotification({
      message: t('popup.payment'),
      type: 'success'
    })
  }
})
</script>

<style lang="scss" scoped>

</style>